import { RootState } from 'renderer/shared/state/store';

export const selectUser = (state: RootState) => state.user;

export const selectUserId = (state: RootState) =>
  (state.user && state.user.role !== 'public' && state.user._id) || undefined;

export const selectUserRole = (state: RootState) =>
  state.user && state.user.role;

export const selectIsAdmin = (state: RootState) =>
  state.user && state.user.role === 'admin';

export const selectIsLoggedIn = (state: RootState) =>
  state.user && state.user.role !== 'public';
